import { Avatar } from '@common/material'
import { Box, Text } from '@common/fundamentals'
import { SxProps, Theme } from '@mui/material/styles'
import { Palette } from '@core/theme/color-palette-siteassist'

type UserAvatarProps = {
  user: {
    firstName: string
    lastName: string
  }
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  width?: number
  height?: number
  sx?: SxProps<Theme> & {
    width?: number
    height?: number
  }
}
export const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  onClick,
  sx,
}) => {
  const capitalFirstLetter = (name: string) => {
    if (!name) {
      return ''
    }
    return name?.[0]?.toUpperCase()
  }

  const userInitials =
    capitalFirstLetter(user?.firstName) + capitalFirstLetter(user?.lastName)

  return (
    <Box onClick={onClick} sx={{ cursor: 'pointer' }} data-test={'user-avatar'}>
      <Avatar sx={{ bgcolor: Palette.Grey['400'], ...sx }}>
        <Text fontSize={sx?.width ? sx.width / 2 : 'inherit'}>
          {userInitials}
        </Text>
      </Avatar>
    </Box>
  )
}
